import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { queryKeys } from "@/lib/query-keys";
import { riderService } from "@/services/rider";
import type { RiderListParams } from "@/services/rider";

import type { CreateRiderReq, UpdateRiderReq } from "@artisancode/api-types";

export function useRiders(params?: RiderListParams) {
  return useQuery({
    queryKey: queryKeys.riders.list(params as Record<string, unknown>),
    queryFn: () => riderService.list(params),
  });
}

export function useCreateRider() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateRiderReq) => riderService.create(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.riders.all }),
  });
}

export function useUpdateRider() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }: { id: string } & UpdateRiderReq) =>
      riderService.update(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.riders.all }),
  });
}

export function useDeleteRider() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => riderService.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.riders.all }),
  });
}
